module.exports = __webpack_public_path__ + "img/cam_selector.6c6b37cf.png";